export const ProfileFieldsWorkout = {
  bindings: {
    form: '<',
    member: '<',
    isEditing: '<',
    questions: '<',
    onUpdate: '&',
  },

  template: `
    <div class="row">
      <div class="col-md-4">
        <h5>Workouts</h5>
        <p>
          Select your Workout Profile. We will use your settings to show you
          daily workout inspiration.
        </p>
      </div>
      <div class="col-md-8" ng-switch="$ctrl.isEditing">
        <div ng-switch-when="false"
          ng-repeat="item in $ctrl.questions track by $index">
          <form-group-row>
            <form-group-left>
              <form-label>
                {{ item.label }}
              </form-label>
            </form-group-left>
            <form-group-right>
              <div class="col-form-label pb-0">
                {{ item.answer }}
              </div>
            </form-group-right>
          </form-group-row>
          <hr ng-hide="$last">
        </div>
        <div class="form-group"
          ng-switch-when="true"
          ng-repeat="item in $ctrl.questions track by $index">
          <form-label>
            {{ item.question }}
          </form-label>
          <form-fieldset
            form="$ctrl.form"
            key="voomeProfile.preferences.{{ item.key }}"
            list="$ctrl.member.voomeProfile.preferences[item.key]"
            type="{{ item.type }}"
            on-update="$ctrl.onUpdate({ key: key, value: value })">
          </form-fieldset>
        </div>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileFieldsWorkout.js